export enum EngagementWallPlannerMode {
  Group = "group",
  Wrap = "wrap"
}
